import React from 'react';
import './Toast.css';
import { useApp } from '../../context/AppContext';

export default function Toast() {
  const { toast } = useApp();
  return (
    <div className={`toast ${toast.type === 'err' ? 'toast-err' : ''} ${toast.visible ? 'toast-show' : ''}`}>
      {toast.type === 'ok' ? '✓ ' : '⚠ '}{toast.msg}
    </div>
  );
}
